import React, { CSSProperties, FC } from 'react';

interface Props {
  className?: string;
  size?: number;
  color?: string;
  style?: CSSProperties;
}

export const ChevronDownIcon: FC<Props> = ({ className, size = 24, color = 'currentColor', style }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path d="M7.41 7.83984L12 12.4198L16.59 7.83984L18 9.24984L12 15.2498L6 9.24984L7.41 7.83984Z" />
      <path d="M7.41 7.83984L12 12.4198L16.59 7.83984L18 9.24984L12 15.2498L6 9.24984L7.41 7.83984Z" />
    </svg>
  );
};
